import script from "./InterpretingConversationSequence.vue?vue&type=script&setup=true&lang=js"
export * from "./InterpretingConversationSequence.vue?vue&type=script&setup=true&lang=js"

import "./InterpretingConversationSequence.vue?vue&type=style&index=0&id=6c820650&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c820650"]])

export default __exports__